import { useState } from "react"
import { useQuery } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import { TOKEN, config } from "../../config";
import axios from "../../api/newAxios";
const cookies = new Cookies();

const useReadWithGet = ({
    url, initialData,onSuccess,enabled=true
}) => {
    const [paramsObject, setGetListParams] = useState(initialData)
    const list = useQuery([url, paramsObject], () => getUsers(paramsObject), {
        refetchOnWindowFocus: false,
        enabled: enabled,
        onSuccess(data) {
              onSuccess?.(data)
        },
        onError(err) {
            //   onError?.(err)
        },
        onSettled() {
            //   onSettled?.()
        }
    })
    const getUsers = async (paramsObject) => {
        let token = cookies.get(TOKEN);
        let fd = new FormData()
        for (var key in paramsObject) {
            fd.append(key, paramsObject[key]);
        }
        const response = await axios({
            method: "POST",
            data: fd,
            url: `/${url}`,
            headers: { Authorization: token ? `Bearer ${token}` : '', }
        })
        return response.data
    }

    return { list, paramsObject, setGetListParams }
}

export default useReadWithGet